import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import EditorialKittenHero from "./sections/EditorialKittenHero";
import Kittengallery from "./sections/Kittengallery";
import Testimonials from "./sections/Testimonials";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Navigation />
      <EditorialKittenHero />
      <Kittengallery />
      <Testimonials />
      <Footer />
    </div>;
}